























































import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import { sleep } from '@ivy/fts/utils'
import { uploadEvent } from '@/api/goods/statistics'

@Component({
  components: {},
})
export default class extends Vue {
  recordList: any[] = []
  curPage: number = 1
  loadAll: boolean = false
  loading: boolean = false
  PLATFORM_MAP: any = {
    1: '常青藤爸爸APP',
    2: '小常爱学习APP',
    3: '小常爱识字APP',
    4: 'H5',
    10: '天猫',
    11: '有赞',
    12: '抖音',
    13: '微信视频号',
    14: '小红书',
    15: '达人带货',
    16: '抖音',
    17: '爱逛',
    18: '视频号',
  }
  refund_statustxt(txt) {
    if (txt == 1) {
      return '部分退款'
    } else if (txt == 2) {
      return '全部退款'
    }
    return ''
  }
  async mounted() {
    await env.init()
    if (env.type === 'web') return this.$Toast('请在App或微信中打开')
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
    this.getData()
  }
  //设置数据
  async getData() {
    this.loading = true
    let {
      data,
    } = await this.$axios.get(
      '/api/goods/shop/market/goldBack/getTransedOrders',
      { params: { limit: 1000 } }
    )
    this.loading = false
    this.recordList = this.recordList.concat(data)
  }
  loadMore() {
    if (!this.loadAll) {
      this.curPage++
      this.getData()
    }
  }
}
